export default __webpack_public_path__ + "static/SRUS DSL4 - Product Specifications & Technical Data-65a69e584d7102f677533501ba2cb5d2.pdf";